
import Nav from '../../components/breadcrumb';
import PageHeader, { Title } from '../../components/pageheader';
import { useNavigate } from 'react-router-dom';
import ProjectForm from './project-form';

const ProjectObject = {
    code: "", title: "", client_id: "", start_date: "", end_date: "", billing_cycle: "", billing_mode: ""
}

const NewProject = () => {

    const nav_items = [
        { title: 'Projects', href: '/app/projects' },
        { title: 'New Project' }
    ];

    const navigate = useNavigate();

    const handleSubmit = (details) => {
        navigate(`/app/projects/${details.id}`);
    }


    return (
        <>
            <Nav items={nav_items} />

            <div className="max-800 p-2">
                <ProjectForm
                    details={ProjectObject}
                    onSubmit={handleSubmit}
                    action="create"
                />
            </div>
        </>
    )

}

/**
 * 
 * @param {Object} props
 * @param {import('../../resources/api/projects').ProjectObject} props.details 
 * @param {React.Dispatch<React.SetStateAction<import('../../resources/api/projects').ProjectObject>>} props.setDetails 
 */
const EditProject = ({ details, setDetails }) => {

    const nav_items = [
        { title: 'Projects', href: '/app/projects' },
        { title: details.title, href: `/app/projects/${details.id}` },
        { title: 'Edit Details' }
    ];

    const navigate = useNavigate();

    const handleSubmit = (details) => {
        setDetails(d => ({ ...d, ...details }));
        navigate(`/app/projects/${details.id}`);
    }


    return (
        <>
            <Nav items={nav_items} />

            <PageHeader maxWidth="800">
                <Title>{details.title}</Title>
            </PageHeader>

            <div className="max-800 p-2">
                <ProjectForm
                    details={details}
                    onSubmit={handleSubmit}
                    action="edit"
                />
            </div>
        </>
    )

}


export { NewProject, EditProject };